import { Injectable } from '@angular/core';
import { SDM_ENVIRONMENT } from '../config/config';

@Injectable({ providedIn: 'root' })
export class NavigationUtilService {
	private cmHost(): string {
		// production/u-sdmweb -> cm.scanburapps.com; d-sdmweb/t-sdmweb (and any other non-prod env) -> d-cm.scanburapps.com
		return (SDM_ENVIRONMENT === 'production' || SDM_ENVIRONMENT === 'u')
			? 'cm.scanburapps.com'
			: 'd-cm.scanburapps.com';
	}

	gotoCM(location: Location | { href: string }, path: string) {
		if (SDM_ENVIRONMENT === 'd0') {
			location.href = 'http://localhost:4200/' + path;
		} else {
			location.href = `https://${this.cmHost()}/${path}`;
		}
	}
}
